import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const VercelIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 128 128"><path d="M64.002 8.576 128 119.424H0Zm0 0" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VercelIcon;